import { useEffect, useContext } from 'react'
import { Paper, Skeleton, Typography } from '@mui/material'
import RoleContext from '../auth/RoleContext'
import { ApiGateway, FeatureFlags } from '../config/config'
import FileListControl from '../form/FileListControl'
import { Stack } from '@mui/system'

export default function AuthorizationFilesCard(props = {}) {
  const roleDetails = useContext(RoleContext)

  const { mfrProfile, authorization, readOnly, noTable } = props

  useEffect(() => {
    
  }, [authorization])

  const isMfiAdminOrAbove = roleDetails.isAdminUser()
  const editable = readOnly ? false : isMfiAdminOrAbove && FeatureFlags.facAuthQseUpdates ? authorization.workflowStatus === 'DRAFT' || (isMfiAdminOrAbove && authorization.isHistorical === true) : authorization.workflowStatus === 'DRAFT'
  return (
        <Paper elevation={1} sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: '100%', padding: "5px" }}>
          <Stack rowGap={1}>

            {/* Latest Letter */}
              <Typography fontWeight='bold' variant="body2" color="text.secondary">Latest authorization letter</Typography>
              
              {props.loading && <Skeleton />}
              {!props.loading && authorization?.id && <FileListControl
                listFilesUrl={`${ApiGateway.authorizations}/${authorization.id}/files`}
                showLastModified={true}
                showActions={editable}
                enableUpload={editable}
                enableDownload={true}
                getFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.id}/files/`}
                getPutFileUrlServiceAddr={`${ApiGateway.authorizations}/${authorization.id}/files/new-file-url`}
                removeFileUrl={`${ApiGateway.authorizations}/${authorization.id}/files`}
                altFileNameColumnLabel='Original File Name'
                noTable={noTable}
              />}

            {/* Past Letters */}
            {/* <Grid item xs={4}>
              <Typography fontWeight='bold' variant="body2" color="text.secondary">Latest authorization letter</Typography>
              <br />
              <FileListControl
                showLastModified={true}
                showActions={true}
                enableUpload={true}
                enableDownload={true}
              />
            </Grid> */}

          </Stack>
        </Paper>
  )
}